import { makeStyles, Skeleton, SkeletonItem, tokens } from '@fluentui/react-components';

export default function ListItemSkeleton() {
	const classes = useStyles();

	return (
		<Skeleton className={classes.root}>
			<SkeletonItem className={classes.skeletonItem} />
		</Skeleton>
	);
}

export const useStyles = makeStyles({
	root: {
		padding: '16px',
	},
	skeletonItem: {
		backgroundColor: tokens.colorNeutralBackground5,
		':after': {
			backgroundImage: `linear-gradient(to right, ${tokens.colorNeutralBackground5} 0%, ${tokens.colorNeutralBackground2} 50%, ${tokens.colorNeutralBackground5} 100%)`
		}
	}
});